/**
 * action types
 */
export const SET_COURSE_PROGRESS = 'SET_COURSE_PROGRESS';
export const SET_COURSE_PROGRESS_FOR_USER = 'SET_COURSE_PROGRESS_FOR_USER';
export const ON_ENTER_COURSE_PROGRESS_SCREEN =
  'ON_ENTER_COURSE_PROGRESS_SCREEN';
export const PROGRESS_PAGE_START = 'PROGRESS_PAGE_START';
export const PROGRESS_PAGE_SUCCESS = 'PROGRESS_PAGE_SUCCESS';
export const PROGRESS_PAGE_FAILED = 'PROGRESS_PAGE_FAILED';
